export default {
  data() {
    return {
      // 所有状态
      statusList: {
        online: {
          name: "Online's Device",
          value: 1,
        },
        offline: {
          name: "Offline's Device",
          value: 2,
        },

        normal: {
          name: 'No fault',
          value: 3,
        },
        unavailable: {
          name: "Fault's device, unavailable.",
          value: 4,
        },
        fault: {
          name: "Fault's device, partially available.",
          value: 5,
        },
        alarm: {
          name: "Alarm's Device",
          value: 6,
        },
        'vpn-online': {
          name: 'VPN Online',
          value: 7,
        },
        'vpn-offline': {
          name: 'VPN Offline',
          value: 8,
        },
      },
    };
  },
};
